import $ from 'jquery';
import 'slick-carousel';
import { TagManager } from '@dealersites/tag-manager/tag-manager';
import { InventorySearchEvents } from '@dealersites/inventory/events';

const srpPage = $('#vehicle-results-container');

if (srpPage.length !== 0) {
  const searchURL = new URL(window.location.href);
  const searchParams = new URLSearchParams(searchURL.search);

  if (searchParams.size > 0) {
    // console.log("ANALYTICS ON FILTERS THAT CAUSE PAGE LOAD");
    if (searchParams.has('title')) {
      sendTypedfAnalytics();
      sendAnalytics();
    } else {
      sendAnalytics();
    }
  } else {
    // console.log("GENERAL LOAD - INITIAL PAGE LOAD OR NO FILTER HAS BEEN SET OR FILTER HAS BEEN RESET OR PAGE REFRESHED");
    sendAnalytics();
  }

  $(document).on(InventorySearchEvents.POST_RENDER, () => {
    // console.log("ANALYTICS + PAGEVIEW ON FILTER, SORT (POST-RENDER EVENT)")
    // facet filters and sort
    TagManager.trackEvent('pageview');
    sendAnalytics();
  });
}

$('.controls').each(function () {
  const id = $(this).data('slider-id');
  const $testSlider = $(`.${id}`);

  const CONFIG = {
    carouselClick: {
      assetPosition: 1,
      assetName: id,
    },
  };

  $testSlider.on('afterChange', function (event, slick, currentSlide) {
    let currentPos = currentSlide + 1;
    CONFIG.carouselClick.assetPosition = currentPos;
    // console.log("Sending CONFIG (Carousel CHANGE): ", CONFIG);
  });

  $testSlider.on('click', function () {
    // console.log("Sending CONFIG (Carousel CLICK): ", CONFIG);
    TagManager.trackEvent('carouselClick', CONFIG);
  });
});

export function sendAnalytics() {
  const $analytics = $('.srp-analytics');

  const COUNT = $analytics.attr('data-count');
  const PRESETS = $analytics.attr('data-analytics');

  const CONFIG = {
    countSearchResults: COUNT,
    filterSearch: JSON.parse(PRESETS),
  };
  // console.log('Sending CONFIG:', CONFIG);
  TagManager.trackEvent('filterSearch', CONFIG);
}

export function sendTypedfAnalytics() {
  const $analytics = $('.srp-analytics');
  const TITLE = $analytics.attr('data-search');
  if (TITLE) {
    const CONFIG = {
      typedSearchContent: TITLE,
    };
    // console.log("Sending CONFIG (Typed): ", CONFIG);
    TagManager.trackEvent('typedSearch', CONFIG);
  }
}

$(`[href*="service-appointment"]`).on('click', function (e) {
  e.preventDefault();
  const url = $(this).attr('href');
  const target = $(this).attr('target');

  // console.log('service appointment clicked: ', url, target);
  TagManager.trackEvent('scheduleServiceClick');
  if (target == "_blank") {
    window.open(url, target);
  } else {
    window.location.href = url;
  }
});
